(function() {
  const contactForm = document.getElementById("ContactForm");
  if (!contactForm) return;
  const emailInput = document.getElementById("ContactForm-email");
  const submitBtn = contactForm.querySelector('button[type="submit"]');
  if (!emailInput || !submitBtn) return;
  const errorMsg = document.createElement("p");
  errorMsg.style.cssText = "color: #e02b2b; font-size: 16px; margin-top: 6px; display: none;";
  errorMsg.setAttribute("aria-live", "polite");
  emailInput.insertAdjacentElement("afterend", errorMsg);
  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());
  }
  function showError(message) {
    errorMsg.textContent = message;
    errorMsg.style.display = "block";
    emailInput.setAttribute("aria-invalid", "true");
    emailInput.style.borderColor = "#e02b2b";
  }
  function clearError() {
    errorMsg.style.display = "none";
    errorMsg.textContent = "";
    emailInput.removeAttribute("aria-invalid");
    emailInput.style.borderColor = "";
  }
  function setButtonState(enabled) {
    submitBtn.disabled = !enabled;
    submitBtn.style.cssText = enabled ? "opacity: 1; cursor: pointer; pointer-events: auto; transition: opacity 0.2s ease;" : "opacity: 1; cursor: not-allowed; pointer-events: auto; transition: opacity 0.2s ease;";
  }
  setButtonState(false);
  emailInput.addEventListener("input", function() {
    const val = emailInput.value.trim();
    if (val === "") {
      clearError();
      setButtonState(false);
    } else if (isValidEmail(val)) {
      clearError();
      setButtonState(true);
    } else {
      showError("Please enter a valid email address.");
      setButtonState(false);
    }
  });
  emailInput.addEventListener("blur", function() {
    const val = emailInput.value.trim();
    if (val === "") {
      showError("Email address is required.");
      setButtonState(false);
    } else if (!isValidEmail(val)) {
      showError("Please enter a valid email address.");
      setButtonState(false);
    } else {
      clearError();
      setButtonState(true);
    }
  });
  contactForm.addEventListener("submit", function(e) {
    const val = emailInput.value.trim();
    if (val === "" || !isValidEmail(val)) {
      e.preventDefault();
      showError(val === "" ? "Email address is required." : "Please enter a valid email address.");
      setButtonState(false);
      emailInput.focus();
    } else {
      clearError();
      setButtonState(true);
    }
  });
})();
//# sourceMappingURL=contact-form.js.map
